import { render, staticRenderFns } from "./mailing-drop-archive.vue?vue&type=template&id=81a82866&scoped=true"
import script from "./mailing-drop-archive.vue?vue&type=script&lang=js"
export * from "./mailing-drop-archive.vue?vue&type=script&lang=js"
import style0 from "./mailing-drop-archive.vue?vue&type=style&index=0&id=81a82866&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81a82866",
  null
  
)

export default component.exports